module.exports = "/packs/media/images/illness-f598b9048dd735271d3dc691a5cebdfb.png";